import React from "react";
import Hero from "../components/Hero";
import Service from "../components/Service";
import FeaturedInsights from "../components/FeaturedInsights";
import Memberships from "../components/Memberships";

const HomePage = () => {
  return (
    <div>
      <Hero />
      <Service />
      <FeaturedInsights />
      <Memberships />
    </div>
  );
};

export default HomePage;
